export default "<div class=\"subcontainer\">\n    <app-list [screenDescriptor]=\"screenStructure\" [screenHandler]=\"screenHandler\"></app-list>\n</div>";